import { startOfMonth } from 'date-fns';
import { ReportSettingRunWith } from '../../../../models/reportTypeSetting';
import { getStartMonthDate } from '../../../../util';
import { getCustomCalendarPeriodStartDate } from '../../../../util/customCalendarPeriods';
import { ReportSettingMaturityState } from '../Maturity';
import { PITValidationData } from './validateReportSettingPITStateForReportType';
import { formatDateByLocale } from '../../../../util/dateHelpers';

export const validateReportSettingPITStateMaturity = ({
  pitAsOfDate,
  reportSettingState,
  customCalendarSettings,
  localePreference,
}: PITValidationData): string[] => {
  const {
    shortStartDate,
    selectedRunWith,
  } = reportSettingState as ReportSettingMaturityState;
  const isCustomCalendarEnabled =
    customCalendarSettings?.isCustomCalendarEnabled;

  const reportStartDate = isCustomCalendarEnabled
    ? getCustomCalendarPeriodStartDate(shortStartDate, customCalendarSettings)
    : getStartMonthDate(shortStartDate);
  const today = new Date();
  const formattedText = isCustomCalendarEnabled ? 'period/year' : 'month/year';

  const errs = [];
  if (pitAsOfDate < reportStartDate) {
    errs.push(
      `As of date cannot occur before Report Start Date of ${formatDateByLocale(
        reportStartDate,
        localePreference,
      )}. Please adjust dates or disable Point in Time.`,
    );
  }
  if (
    selectedRunWith.value === ReportSettingRunWith.RunWithSpotRate ||
    selectedRunWith.value === ReportSettingRunWith.None
  ) {
    errs.push(
      'Currently, LeaseQuery only supports the option to Run with Prior Month Spot Rate when running with a past as of date. Please contact support@leasequery.com for additional details.',
    );
  }
  if (startOfMonth(today) < reportStartDate) {
    errs.push(
      `As of date cannot be used if today's ${formattedText} is less than selected start ${formattedText}. Please adjust dates or disable Point in Time.`,
    );
  }

  return errs;
};
